import { render, staticRenderFns } from "./QuestionInfo.vue?vue&type=template&id=5b6b9926&scoped=true&"
import script from "./QuestionInfo.vue?vue&type=script&lang=ts&"
export * from "./QuestionInfo.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionInfo.vue?vue&type=style&index=0&id=5b6b9926&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6b9926",
  null
  
)

export default component.exports